import { styled } from '@mui/material';

export const wrapperStyles = {
  padding: '24px',
  width: 'min(800px, calc(100vw - 16px))',
  maxHeight: 'calc(100vh - 16px)',
  overflow: 'auto',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  boxShadow: '5px 0px 12px 0px #00000026, 0px 5px 12px 0px #00000026',
};

export const titleStyles = {
  fontWeight: 600,
  fontSize: '1.8rem',
  lineHeight: '2.1rem',
  color: ({ palette }) => palette.text.primary,
  marginBottom: '12px',
};

export const textStyles = {
  fontWeight: 400,
  fontSize: '1.4rem',
  lineHeight: '2.2rem',
  color: ({ palette }) => palette.text.secondary,
};

export const findingReportTextStyles = {
  fontWeight: 400,
  fontSize: '1.2rem',
  lineHeight: '2rem',
  color: ({ palette }) => palette.text.secondary,
};

export const tableContainerStyles = {
  borderRadius: '5px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const tableStyles = {
  tableLayout: 'fixed',
  width: '100%',
};

export const getHeadCellStyles = ({ width }) => ({
  width,
  padding: '4px 0 4px 15px',
});

export const findingButtonCustomStyles = {
  width: '91px',
  height: '28px',
  minHeight: '28px',
  padding: '4px 7px',
};

export const StatItemWrapper = styled('div')`
  display: flex;
  gap: 11px;
  align-items: center;
`;

export const FindingReportWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ausTypeWrapperStyles = {
  display: 'flex',
  height: '56px',
  alignItems: 'center',
  justifyContent: 'flex-end',
  paddingRight: '121px',
  borderRadius: '8px',
  backgroundColor: ({ palette }) => palette.background.secondary,
  marginTop: '12px',
};

export const radioGroupCustomStyles = {
  justifyContent: 'flex-end',
  '.radio-group': {
    gap: '140px',
  },
};

export const getCellStyles = customStyles => ({
  padding: '4px 15px',
  ...customStyles,
});
